angular.module('TetherApp').directive('tetherFile', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherFile.html'
    }
});
